import { rankWith, schemaMatches } from '@jsonforms/core';

export default rankWith(
  5, //increase rank as needed
  schemaMatches((schema) => schema.hasOwnProperty('options') && schema['options'].hasOwnProperty('format') && schema['options']['format'] === 'time')
);
